<template>
  <layout-component>
    <div class="container" v-if="event">

        <!-- Event title  -->
        <div class="row justify-content-md-center banner pb-1 pb-md-0">
          <div class="col-md-8 title-wrapper">
            <p class="cat-wrapper">
              <span>{{ $i18n.locale == 'fr' ? event.category.name : event.category.name_en }}</span>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="3" height="3" viewBox="0 0 3 3">
                  <circle id="Ellipse_12" data-name="Ellipse 12" cx="1.5" cy="1.5" r="1.5" fill="#7b947b"/>
                </svg>
              </span>
              <span class="level">{{ event.label.name }}</span>
            </p>
            <h1 class="left-bullet">{{ $i18n.locale == 'fr' ? event.name : event.name_en }}</h1>
          </div>
        </div>

        <!-- Event cover  -->
        <div class="row mb-6">
          <div class="col-md-10 offset-md-1">
            <div class="img-wrapper img-header">
              <div class="noise">
                <img class="img-fluid" :title="`Cover ${event.name_en}`" v-if="event.cover" :src="'/storage/'+event.cover" />
              </div>
            </div>
          </div>
        </div>

        <!-- Event informations  -->
        <div class="row mb-3">
          <div class="col-md-6 offset-md-1 mb-3 mb-md-0">

            <!-- Registered  -->
            <eventRegistered :event="event" />

            <!-- Infos-->
            <eventInfos :event="event" />

            <!-- Body -->
            <div class="body">
              <div v-html="$i18n.locale == 'fr' ? event.body : event.body_en" class="body"></div>

              <div v-if="event.speakers.length" class="speakers">
                <div v-for="speaker in event.speakers" :key="speaker.id" :id="'#speaker-' + speaker.id" :class="'speaker-' + speaker.id">
                  <h3>{{ speaker.name }}</h3>
                  <div v-html="$i18n.locale == 'fr' ? speaker.description : speaker.description_en"></div>
                </div>
              </div>

            </div>

          </div>
          
          <eventActions :event="event" />

        </div>

        <!-- Other events  -->
        <template v-if="event.otherEvents.length">
        
          <div class="row pt-3 pt-md-4 other-posts">
            <div class="col-md-8 pb-2 pb-md-3 offset-md-2">
              <h2 class="left-bullet" v-html="$t('title-01')"></h2>
            </div>
          </div>
  
          <div class="row other-posts">
            <div v-for="event in event.otherEvents" class="card-event event col-12" :key="event.id">
              <router-link :to="'/events/'+event.slug">
                <div class="img-wrapper">
                  <div class="noise">
                      <div class="ratio">
                        <img class="img-fluid" :title="`Cover ${event.name_en}`"  v-if="event.cover" :src="'/storage/'+event.cover" />
                      </div>
                  </div>
                </div>
                <div class="category-wrapper">
                  <span class="category">{{ $i18n.locale == 'fr' ? event.category.name : event.category.name_en }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="3" height="3" viewBox="0 0 3 3">
                      <circle id="Ellipse_12" data-name="Ellipse 12" cx="1.5" cy="1.5" r="1.5" fill="#7b947b"/>
                    </svg>
                  </span>
                  <span class="level">{{event.label.name }}</span>
                </div>
                <div class="text-wrapper">
                  <h3>{{ $i18n.locale == 'fr' ? event.name : event.name_en }}</h3>
                  <div v-if="event.end_date && (event.start_date != event.end_date)" class="event-dates">
                    <p>{{'from'|t}} {{ event.start_date | formatDateEvent }}</p>
                    <p>{{'to'|t}} {{ event.end_date | formatDateEvent }}</p>
                  </div>
                  <div v-else class="event-dates">
                    <p>{{'on'|t}} {{ event.start_date | formatDateEvent }}</p>
                  </div>
                  <p class="event-hours">
                    <span>
                      {{ event.from | formatTimeEvent }}
                    </span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="5.447" height="9.48" viewBox="0 0 5.447 9.48">
                        <path id="Tracé_1" data-name="Tracé 1" d="M428.9,772l4.386,4.387-4.386,4.386" transform="translate(-428.547 -771.646)" fill="none" stroke="#03f462" stroke-width="1"/>
                      </svg>
                    </span>
                    <span>
                      {{ event.to | formatTimeEvent }}
                    </span>
                  </p>
                </div>
              </router-link>
            </div>
          </div>

        </template>
        
    </div>

	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        event: null,
        status: null,
        userStatus: null,
        maxTicketsPossible: 0
      }
    },
    created() {
      this.getEvent();
    },
    watch: {
      // call again the method if the route changes
      '$route': 'getEvent'
    },
    methods: {
      getEvent() {
        Vue.axios.get('/events/'+this.$route.params.id).then( ({data}) => {
          this.event = data;
          this.status = this.event.status;
          this.userStatus = this.event.userStatus;
          this.countMaxTicketsPossible();

          // Add name of the event by the local used
          if(this.$i18n.locale == 'fr')
            document.title = this.event ? `Enter the Sonotron - ${this.event.name}` : 'Enter the Sonotron - Event';
          else
            document.title = this.event ? `Enter the Sonotron - ${this.event.name_en}` : 'Enter the Sonotron - Event';
        })
      },
      scrollToAction() {
        animateScrollTo(document.querySelector('.event-participate'), {
          offset: -200,
          passive: true
        });
      },
      countMaxTicketsPossible() {

        if (this.event.max_tickets_per_user && this.event.capacity) {
          this.maxTicketsPossible = this.event.max_tickets_per_user > this.event.ticketsAvailable ? this.event.ticketsAvailable : this.event.max_tickets_per_user;
          return;
        }

        if (this.event.max_tickets_per_user && ! this.event.capacity) {
          this.maxTicketsPossible = this.event.max_tickets_per_user;
          return;
        }

        this.maxTicketsPossible = this.event.ticketsAvailable;
        return;
      }
    },
    mounted() {

      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');

      $('.noise').each(function() {
        if ($(this).is( ':in-viewport' ) ) {
          $(this).addClass('in-viewport');
        } else {
          $(this).removeClass('in-viewport');
        }
      });
    }
  }
</script>

<i18n>
    {
      "en": {
        "title-01": "<span class='title-anim-wrapper'><span class='title-anim'>You may be</span></span> <span class='title-anim-wrapper'><span class='title-anim'>interested in</span></span>",
        "title-btn": "Check it",
        "from": "From",
        "to": "To",
        "on": "On",
        "title-room": "Room",
        "title-event": "Event",
        "event-free": "Free",
        "infos-dates": "Date and hours",
        "infos-duration": "Duration",
        "infos-price": "Price",
        "infos-btn-participate": "Register",
        "infos-level": "Level",
        "infos-speakers": "Speaker(s)",
        "infos-place": "Place",
        "infos-btn-map": "Getting there",
        "participate-title": "I register to <br>the event",
        "notification-title": "Notify me!",
        "btn-subscribe": "Register",
        "btn-notify-me": "Notify me",
        "btn-unnotify-me": "Unnotify me",
        "btn-waiting-list": "Join the waiting list",
        "guest-title": "Please log in to participate",
        "create-account": "Create my account",
        "login": "Login",
        "is-complete": "Complete",
        "is-complete-text": "Sorry, all available spots have been reserved. To join the waiting list, please send an e-mail to 1535@differdange.lu",
        "error-field-empty": "Field required",
        "error-nb-tickets": "Tickets limited to ",
        "tickets-nb": "Tickets",
        "tickets-nb-max": "Tickets (max. ",
        "not-enough-places": "Not enough places available."
      },
      "fr": {
        "title-01": "<span class='title-anim-wrapper'><span class='title-anim'>Ceci pourrait</span></span> <span class='title-anim-wrapper'><span class='title-anim'>vous interesser</span></span>",
        "title-btn": "Voir",
        "from": "Du",
        "to": "Au",
        "on": "Le",
        "title-room": "Salle",
        "title-event": "Événement",
        "event-free": "Gratuit",
        "infos-dates": "Date et horaires",
        "infos-duration": "Durée",
        "infos-price": "Prix",
        "infos-btn-participate": "Inscription",
        "infos-level": "Niveau",
        "infos-speakers": "Intervenant(s)",
        "infos-place": "Lieu",
        "infos-btn-map": "S'y rendre",
        "participate-title": "Je m'inscris <br>à l'event",
        "notification-title": "Prévenez-moi !",
        "btn-subscribe": "Je m'inscris",
        "btn-notify-me": "Prévenez-moi",
        "btn-unnotify-me": "Ne plus me prévenir",
        "btn-waiting-list": "Rejoindre la liste d'attente",
        "guest-title": "Connectez vous pour vous inscrire",
        "create-account": "Créer mon compte",
        "login": "Me connecter",
        "is-complete": "Complet",
        "is-complete-text": "Désolé, toutes les places disponibles ont été réservées. Pour vous inscrire dans la liste d'attente, veuillez nous envoyer un courriel à l'adresse : 1535@differdange.lu",
        "error-field-empty": "Champ obligatoire.",
        "error-nb-tickets": "Places limitées à ",
        "tickets-nb": "Nombre de places",
        "tickets-nb-max": "Nombre de places (max.",
        "not-enough-places": "Pas assez de places disponibles."
      }
    }

</i18n>
